module.exports = {
          srcSet: __webpack_public_path__ + "2cbbc3ef81a588fe7636f9b5b4ea23b2-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "2cbbc3ef81a588fe7636f9b5b4ea23b2-90.png",width: 90,height: 4}],
          src: __webpack_public_path__ + "2cbbc3ef81a588fe7636f9b5b4ea23b2-90.png",
          toString:function(){return __webpack_public_path__ + "2cbbc3ef81a588fe7636f9b5b4ea23b2-90.png"},
          
          width: 90,
          height: 4
        }